export function buildCvDownloadHtml(pressUrl, canvasRebelUrl) {
  return `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Love Quetee / Artist CV</title>
  <style>
    :root {
      color-scheme: light;
      --ink: #161616;
      --soft-ink: #535353;
      --line: #9a9a9a;
      --paper: #ffffff;
    }
    * { box-sizing: border-box; }
    body {
      margin: 0;
      background: var(--paper);
      color: var(--ink);
      font-family: Arial, Helvetica, sans-serif;
      font-size: 12px;
      line-height: 1.42;
    }
    .cv {
      width: min(100% - 4rem, 920px);
      margin: 0 auto;
      padding: 3.2rem 0 4rem;
    }
    .cv-header {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(20rem, 0.92fr);
      gap: 3rem;
      align-items: end;
      padding-bottom: 1.3rem;
      border-bottom: 1px solid var(--ink);
    }
    .cv-name {
      margin: 0;
      font-size: clamp(3.2rem, 8vw, 5.8rem);
      font-weight: 300;
      letter-spacing: -0.07em;
      line-height: 0.82;
    }
    .cv-name em {
      display: block;
      font-style: normal;
    }
    .cv-subtitle {
      margin: 1.15rem 0 0;
      color: var(--soft-ink);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 0.95rem;
    }
    .cv-contact {
      display: grid;
      grid-template-columns: 4.9rem minmax(0, 1fr);
      gap: 0.45rem 0.8rem;
      align-self: stretch;
      padding: 1.1rem 1.25rem 1.35rem;
      border: 1px solid #5c5c5c;
      border-bottom: 0.55rem solid #000;
      font-size: 0.92rem;
    }
    .cv-contact dt { font-weight: 700; }
    .cv-contact dd { margin: 0; color: var(--soft-ink); overflow-wrap: anywhere; }
    .cv-contact a { color: inherit; }
    .cv-contact dd.cv-social {
      font-size: 0.72rem;
      letter-spacing: -0.015em;
      white-space: nowrap;
    }
    .cv-rule {
      height: 0.55rem;
      margin-top: 0.28rem;
      border-top: 2px solid var(--ink);
      border-bottom: 1px solid var(--ink);
    }
    .cv-intro {
      max-width: 42rem;
      margin: 1.6rem 0 0;
      color: var(--soft-ink);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 1rem;
    }
    .cv-section {
      margin-top: 2.15rem;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .cv-section h2 {
      margin: 0 0 1rem;
      padding: 0 0 0.45rem;
      border-bottom: 1px solid var(--line);
      font-family: Georgia, "Times New Roman", serif;
      font-size: 1.24rem;
      font-weight: 700;
      line-height: 1.1;
    }
    .cv-entry {
      gap: 1rem;
      padding: 0.22rem 0;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    .cv-date {
      color: var(--soft-ink);
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
    }
    .cv-entry-title { font-weight: 700; }
    .cv-entry-detail { color: var(--soft-ink); }
    .cv-skills {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0.45rem 2.5rem;
      margin: 0;
      padding-left: 1.2rem;
    }
    .cv-skills li::marker { color: #000; }
    .cv-list {
      display: grid;
      gap: 0.45rem;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .cv-list li { padding-bottom: 0.35rem; border-bottom: 1px solid #d2d2d2; }
    .cv-footer {
      margin-top: 2.5rem;
      padding-top: 0.7rem;
      border-top: 1px solid var(--line);
      color: var(--soft-ink);
      font-size: 0.68rem;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }
    @media (max-width: 680px) {
      body { font-size: 11px; }
      .cv { width: min(100% - 2rem, 920px); padding-top: 2rem; }
      .cv-header { grid-template-columns: 1fr; gap: 1.5rem; }
      .cv-contact { max-width: 100%; }
      .cv-entry { grid-template-columns: 1fr; gap: 0.1rem; }
      .cv-skills { grid-template-columns: 1fr; gap: 0.35rem; }
    }
    @media print {
      body { background: #fff; }
      .cv { width: 100%; padding: 0; }
      .cv-section { margin-top: 1.65rem; }
      a { color: inherit; text-decoration: none; }
    }
  </style>
</head>
<body>
  <main class="cv">
    <header class="cv-header">
      <div>
        <h1 class="cv-name">Love<em>Quetee</em></h1>
        <p class="cv-subtitle">Fine artist / contemporary painter</p>
      </div>
      <dl class="cv-contact">
        <dt>Address:</dt><dd>Maple Grove, Minnesota</dd>
        <dt>Email:</dt><dd><a href="mailto:love.quetee@gmail.com">love.quetee@gmail.com</a></dd>
        <dt>Instagram:</dt><dd class="cv-social"><a href="https://www.instagram.com/loves_artpage">instagram.com/loves_artpage</a></dd>
        <dt>Website:</dt><dd><a href="https://lovequetee.gallery">lovequetee.gallery</a></dd>
      </dl>
    </header>
    <div class="cv-rule" aria-hidden="true"></div>

    <p class="cv-intro">Liberian-born and Minnesota-based, Love Quetee works across paint, pencil, portraiture, still life, and community-centered projects.</p>

    <section class="cv-section">
      <h2>Education</h2>
      <div class="cv-entry"><div class="cv-date">2023</div><div><span class="cv-entry-title">Fine arts degree</span><span class="cv-entry-detail">, Minnesota State University—Mankato</span></div></div>
      <div class="cv-entry"><div class="cv-date">Current</div><div><span class="cv-entry-title">Master of Fine Arts in Studio Art</span><span class="cv-entry-detail">, Maryland Institute College of Art / Summer Low-Residency</span></div></div>
    </section>

    <section class="cv-section">
      <h2>Professional Experience</h2>
      <div class="cv-entry"><div class="cv-date">2025</div><div><span class="cv-entry-title">Art-A-Whirl</span><span class="cv-entry-detail"> / Minneapolis / Art Festival at A-Mills Artist Lofts, MN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2025</div><div><span class="cv-entry-title">Afro Artivism Event</span><span class="cv-entry-detail"> / Commissioned Live Painting / Vanderbilt University, TN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2024</div><div><span class="cv-entry-title">Arts Advocacy Rally</span><span class="cv-entry-detail"> / Live Painting / Minnesota Citizens for the Arts, MN State Capitol</span></div></div>
      <div class="cv-entry"><div class="cv-date">2023</div><div><span class="cv-entry-title">Live Painting and Artwork Showing</span><span class="cv-entry-detail"> / Little Africa Water Conservation Project</span></div></div>
    </section>

    <section class="cv-section">
      <h2>Awards, Grants &amp; Fellowships</h2>
      <ul class="cv-list">
        <li>Weisman Art Museum Award / Gbanganla</li>
        <li>North Hennepin Community College Award of Excellence / In memory of Lance Kiland</li>
        <li>Minnesota Museum of American Art Purchase Award / Gbanganla</li>
      </ul>
    </section>

    <section class="cv-section">
      <h2>Exhibitions</h2>
      <div class="cv-entry"><div class="cv-date">2026</div><div><span class="cv-entry-title">Minnesota State Fair Fine Art Exhibition</span></div></div>
      <div class="cv-entry"><div class="cv-date">2025</div><div><span class="cv-entry-title">Juried Show “Value of Nature”</span><span class="cv-entry-detail"> / Silverwood Park, MN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2025</div><div><span class="cv-entry-title">“Rhythms of West Africa”</span><span class="cv-entry-detail"> / Artist Talk Show &amp; Workshop Lead</span></div></div>
      <div class="cv-entry"><div class="cv-date">2024</div><div><span class="cv-entry-title">“Memories and Migrations”</span><span class="cv-entry-detail"> / Solidarity Street Art Gallery, St. Paul, MN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2024</div><div><span class="cv-entry-title">City Hall Exhibition</span><span class="cv-entry-detail"> / Golden Valley, MN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2023</div><div><span class="cv-entry-title">Solo Show: “Ghetto Visionary”</span><span class="cv-entry-detail"> / Mankato, MN</span></div></div>
      <div class="cv-entry"><div class="cv-date">2023</div><div><span class="cv-entry-title">Group Senior Show: “Aesthetica”</span><span class="cv-entry-detail"> / Minnesota State University, Mankato</span></div></div>
      <div class="cv-entry"><div class="cv-date">2023</div><div><span class="cv-entry-title">Runway Artwork Exhibition</span><span class="cv-entry-detail"> / Giselle Magazine Annual Fashion Show</span></div></div>
      <div class="cv-entry"><div class="cv-date">Since 2023</div><div><span class="cv-entry-title">Plaqued Artwork</span><span class="cv-entry-detail"> / Austin, MN City Hall</span></div></div>
    </section>

    <section class="cv-section">
      <h2>Upcoming Exhibition</h2>
      <div class="cv-entry"><div class="cv-date">November 7, 2026</div><div><span class="cv-entry-title">Descendants of the Sun</span><span class="cv-entry-detail"> / African Museum, Arts and Culture Center / Saint Paul, Minnesota</span></div></div>
    </section>

    <section class="cv-section">
      <h2>Skills</h2>
      <ul class="cv-skills">
        <li>Oil, acrylic, and colored pencil painting</li>
        <li>Collaborative and community-based art projects</li>
        <li>Art education and workshops</li>
        <li>Environmental and social themes in art</li>
        <li>Realistic portraiture and figure drawing/painting</li>
        <li>Event and exhibition planning</li>
        <li>Cross-cultural artistic collaboration</li>
      </ul>
    </section>

    <section class="cv-section">
      <h2>Press</h2>
      <div class="cv-entry"><div class="cv-date">Press</div><div><span class="cv-entry-title">Love in War</span><span class="cv-entry-detail"> / Mankato Free Press / <a href="${pressUrl}">Read article</a></span></div></div>
      <div class="cv-entry"><div class="cv-date">Press</div><div><span class="cv-entry-title">Meet Love Quetee</span><span class="cv-entry-detail"> / Canvas Rebel / <a href="${canvasRebelUrl}">Read article</a></span></div></div>
    </section>

    <footer class="cv-footer">Love Quetee / artist curriculum vitae</footer>
  </main>
</body>
</html>`;
}
